import React from "react";
import PluginPlaceholder from "../../_editor/components/canvas/plugin_placeholder/PluginPlaceholder";
import "./_matching.scss";
import i18n from "i18next";
import {
  letterFromNumber,
  getRandomColor,
  setRgbaAlpha,
  getButtonText,
} from "../../common/common_tools"; /* eslint-disable react/prop-types */
import colorManager from "../../_editor/components/common/color-picker/ColorPicker";
import { MATCHING_RIGHT_OFFSET } from "../../common/constants";
/* eslint-disable react/prop-types */

export function Matching(base) {
  return {
    getConfig: function () {
      return {
        name: "Matching",
        displayName: IdealStudio.i18n.t("Ordering.Matching.PluginName"),
        category: "evaluation",
        icon: "low_priority",
        initialWidth: "100%",
        initialHeight: "100%",
        initialWidthSlide: "100%",
        initialHeightSlide: "100%",
        flavor: "react",
        isComplex: true,
        defaultCorrectAnswer: 0,
        defaultCurrentAnswer: false,
      };
    },
    getToolbar: function (state) {
      return {
        main: {
          __name: "Main",
          accordions: {
            __score: {
              __name: i18n.t("configuration"),
              icon: "build",
              buttons: {
                nBoxes: {
                  __name: i18n.t("Ordering.Matching.Number"),
                  type: "number",
                  value: state.nBoxes,
                  max: 6,
                  min: 1,
                },
                showFeedback: {
                  __name: i18n.t("Ordering.Matching.ShowFeedback"),
                  type: "checkbox",
                  checked: state.showFeedback,
                },
                buttons: {
                  __name: i18n.t("MultipleChoice.WhichButtons"),
                  type: "radio",
                  value: state.buttons,
                  options: ["tryAgain", "seeAnswer"],
                  labels: [i18n.t("MultipleChoice.tryAgain"), i18n.t("MultipleChoice.seeAnswer")],
                },
                checkAnswerText: {
                  __name: i18n.t("TrueFalse.CheckAnswerText") || "Check Answer Button Text",
                  type: "text",
                  value: getButtonText(state.checkAnswerText, "MultipleChoice.checkAnswer"),
                },
                tryAgainText: {
                  __name: i18n.t("TrueFalse.TryAgainText") || "Try Again Button Text",
                  type: "text",
                  value: getButtonText(state.tryAgainText, "MultipleChoice.tryAgain"),
                  hide: state.buttons !== "tryAgain",
                },
                seeAnswerText: {
                  __name: i18n.t("TrueFalse.SeeAnswerText") || "See Answer Button Text",
                  type: "text",
                  value: getButtonText(state.seeAnswerText, "MultipleChoice.seeAnswer"),
                  hide: state.buttons !== "seeAnswer",
                },
                allowPartialScore: {
                  __name: i18n.t("MultipleAnswer.AllowPartialScore"),
                  type: "checkbox",
                  checked: state.allowPartialScore,
                },
                /* letters: {
                                    __name: i18n.t("Matching.ShowLettersInsteadOfNumbers"),
                                    type: 'checkbox',
                                    checked: state.letters,
                                },*/
              },
            },
            __buttonStyle: {
              __name: IdealStudio.i18n.t("TrueFalse.ButtonStyle") || "Button Style",
              icon: "palette",
              buttons: {
                buttonBackgroundColor: {
                  __name:
                    IdealStudio.i18n.t("TrueFalse.ButtonBackground") || "Button Background Color",
                  type: "color",
                  value: state.buttonBackgroundColor || "#ede9fe",
                },
                buttonTextColor: {
                  __name: IdealStudio.i18n.t("TrueFalse.ButtonTextColor") || "Button Text Color",
                  type: "color",
                  value: state.buttonTextColor || "#111827",
                },
                buttonBorderColor: {
                  __name:
                    IdealStudio.i18n.t("TrueFalse.ButtonBorderColor") || "Button Border Color",
                  type: "color",
                  value: state.buttonBorderColor || "#ede9fe",
                },
                buttonBorderWidth: {
                  __name:
                    IdealStudio.i18n.t("TrueFalse.ButtonBorderWidth") || "Button Border Width",
                  type: "range",
                  value: state.buttonBorderWidth || 1,
                  min: 0,
                  max: 5,
                  step: 1,
                },
                buttonBorderRadius: {
                  __name:
                    IdealStudio.i18n.t("TrueFalse.ButtonBorderRadius") || "Button Border Radius",
                  type: "range",
                  value: state.buttonBorderRadius || 4,
                  min: 0,
                  max: 25,
                  step: 1,
                },
                buttonPadding: {
                  __name: IdealStudio.i18n.t("TrueFalse.ButtonPadding") || "Button Padding",
                  type: "range",
                  value: state.buttonPadding || 8,
                  min: 4,
                  max: 20,
                  step: 1,
                },
                buttonFontSize: {
                  __name: IdealStudio.i18n.t("TrueFalse.ButtonFontSize") || "Button Font Size",
                  type: "range",
                  value: state.buttonFontSize || 14,
                  min: 10,
                  max: 24,
                  step: 1,
                },
                buttonFontWeight: {
                  __name: IdealStudio.i18n.t("TrueFalse.ButtonFontWeight") || "Button Font Weight",
                  type: "select",
                  value: state.buttonFontWeight || "normal",
                  options: [
                    "normal",
                    "bold",
                    "100",
                    "200",
                    "300",
                    "400",
                    "500",
                    "600",
                    "700",
                    "800",
                    "900",
                  ],
                  labels: [
                    i18n.t("styles.font_weight.normal") || "normal",
                    i18n.t("styles.font_weight.bold") || "bold",
                    i18n.t("styles.font_weight.100") || "100",
                    i18n.t("styles.font_weight.200") || "200",
                    i18n.t("styles.font_weight.300") || "300",
                    i18n.t("styles.font_weight.400") || "400",
                    i18n.t("styles.font_weight.500") || "500",
                    i18n.t("styles.font_weight.600") || "600",
                    i18n.t("styles.font_weight.700") || "700",
                    i18n.t("styles.font_weight.800") || "800",
                    i18n.t("styles.font_weight.900") || "900",
                  ],
                },
                buttonHoverBackgroundColor: {
                  __name:
                    IdealStudio.i18n.t("TrueFalse.ButtonHoverBackground") ||
                    "Button Hover Background Color",
                  type: "color",
                  value: state.buttonHoverBackgroundColor || "#ede9fe",
                },
              },
            },
            style: {
              __name: IdealStudio.i18n.t("Ordering.Matching.box_style"),
              icon: "palette",
              buttons: {
                padding: {
                  __name: IdealStudio.i18n.t("Ordering.Matching.padding"),
                  type: "number",
                  value: 10,
                  min: 0,
                  max: 100,
                },
                backgroundColor: {
                  __name: IdealStudio.i18n.t("Ordering.Matching.background_color"),
                  type: "color",
                  value: "#ffffff",
                },
                borderWidth: {
                  __name: IdealStudio.i18n.t("Ordering.Matching.border_size"),
                  type: "number",
                  value: 1,
                  min: 0,
                  max: 10,
                },
                borderStyle: {
                  __name: IdealStudio.i18n.t("Ordering.Matching.border_style"),
                  type: "select",
                  value: "solid",
                  options: [
                    "none",
                    "hidden",
                    "dotted",
                    "dashed",
                    "solid",
                    "double",
                    "groove",
                    "ridge",
                    "inset",
                    "outset",
                    "initial",
                    "inherit",
                  ],
                  labels: [
                    i18n.t("styles.border_style_options.none") || "none",
                    i18n.t("styles.border_style_options.hidden") || "hidden",
                    i18n.t("styles.border_style_options.dotted") || "dotted",
                    i18n.t("styles.border_style_options.dashed") || "dashed",
                    i18n.t("styles.border_style_options.solid") || "solid",
                    i18n.t("styles.border_style_options.double") || "double",
                    i18n.t("styles.border_style_options.groove") || "groove",
                    i18n.t("styles.border_style_options.ridge") || "ridge",
                    i18n.t("styles.border_style_options.inset") || "inset",
                    i18n.t("styles.border_style_options.outset") || "outset",
                    i18n.t("styles.border_style_options.initial") || "initial",
                    i18n.t("styles.border_style_options.inherit") || "inherit",
                  ],
                },
                borderColor: {
                  __name: IdealStudio.i18n.t("Ordering.Matching.border_color"),
                  type: "color",
                  value: "#dbdbdb",
                },
                borderRadius: {
                  __name: IdealStudio.i18n.t("Ordering.Matching.radius"),
                  type: "number",
                  value: 0,
                  min: 0,
                  max: 50,
                },
                opacity: {
                  __name: IdealStudio.i18n.t("Ordering.Matching.opacity"),
                  type: "range",
                  value: 1,
                  min: 0,
                  max: 1,
                  step: 0.01,
                },
              },
            },
          },
        },
      };
    },
    getInitialState: function () {
      return {
        nBoxes: 3,
        showFeedback: true,
        letters: true,
        allowPartialScore: false,
        buttons: "tryAgain",
        checkAnswerText: null,
        tryAgainText: null,
        seeAnswerText: null,
        buttonBackgroundColor: "#ede9fe",
        buttonTextColor: "#111827",
        buttonBorderColor: "#ede9fe",
        buttonBorderWidth: 1,
        buttonBorderRadius: 4,
        buttonPadding: 8,
        buttonFontSize: 14,
        buttonFontWeight: "normal",
        buttonHoverBackgroundColor: "#ede9fe",
        quizColor: "rgba(237, 233, 254, 1)",
      };
    },
    getRenderTemplate: function (state, props = {}) {
      let answers = [];

      let quizColor = state.buttonBackgroundColor || state.quizColor || "#ede9fe";
      let correctAnswers = "";

      for (let i = 0; i < state.nBoxes; i++) {
        // let clickHandler = (e)=>{
        //     props.setCorrectAnswer(parseInt(e.target.value, 10));
        // };
        let isCorrect = props.exercises.correctAnswer === i;
        answers.push(
          <div key={i + 1} className={"row answerRow"}>
            <div className={"col-xs-2 answerPlaceholder"}>
              <div
                className={"answer_letter"}
                style={{
                  backgroundColor: quizColor,
                  color: state.buttonTextColor || "#111827",
                  borderColor: state.buttonBorderColor || "#ede9fe",
                  borderStyle: "solid",
                  borderWidth: `${state.buttonBorderWidth ?? 1}px`,
                  borderRadius: `${state.buttonBorderRadius ?? 4}px`,
                  fontSize: `${state.buttonFontSize ?? 14}px`,
                  fontWeight: state.buttonFontWeight || "normal",
                  padding: `0 ${state.buttonPadding ?? 8}px`,
                  width: "auto",
                  minWidth: "2em",
                }}
              >
                {i + 1}
              </div>
            </div>
            <div className={"col-xs-5"}>
              <PluginPlaceholder
                {...props}
                key={i + 1}
                pluginContainerName={i18n.t("Ordering.Matching.Answer") + " " + (i + 1)}
                pluginDefaultContent={[
                  {
                    plugin: "BasicText",
                    initialState: {
                      __i18nKey: "Ordering.Matching.Answer",
                      __suffix: " " + (1 + i),
                    },
                  },
                ]}
                pluginContainer={"Answer" + i}
              />
            </div>

            <div
              className={"col-xs-5"}
              style={{ position: "relative", display: "flex", alignItems: "center", gap: "8px" }}
            >
              <div style={{ flex: "1 1 auto", minWidth: 0 }}>
                <PluginPlaceholder
                  {...props}
                  key={i + MATCHING_RIGHT_OFFSET + 1}
                  pluginContainerName={i18n.t("Ordering.Matching.Answer") + " " + (i + 1)}
                  pluginDefaultContent={[
                    {
                      plugin: "BasicText",
                      initialState: {
                        __i18nKey: "Ordering.Matching.Answer",
                        __suffix: " " + (1 + i),
                      },
                    },
                  ]}
                  pluginContainer={"Answer" + (i + MATCHING_RIGHT_OFFSET)}
                />
              </div>
              {props.onMoveAnswer ? (
                <div className="assessment-reorder" contentEditable={false}>
                  <button
                    type="button"
                    className="assessment-reorder-btn"
                    aria-label={i18n.t("messages.move_up") || "Move up"}
                    title={i18n.t("messages.move_up") || "Move up"}
                    disabled={i === 0}
                    onClick={(e) => {
                      e.stopPropagation();
                      props.onMoveAnswer(i, -1);
                    }}
                  >
                    ▲
                  </button>
                  <button
                    type="button"
                    className="assessment-reorder-btn"
                    aria-label={i18n.t("messages.move_down") || "Move down"}
                    title={i18n.t("messages.move_down") || "Move down"}
                    disabled={i === state.nBoxes - 1}
                    onClick={(e) => {
                      e.stopPropagation();
                      props.onMoveAnswer(i, 1);
                    }}
                  >
                    ▼
                  </button>
                </div>
              ) : null}
            </div>
            {props.onRemoveAnswer ? (
              <button
                type="button"
                className="assessment-remove-answer"
                aria-label={i18n.t("messages.remove_answer")}
                title={i18n.t("messages.remove_answer")}
                onClick={(e) => {
                  e.stopPropagation();
                  props.onRemoveAnswer(i);
                }}
              >
                ×
              </button>
            ) : null}
          </div>
        );
        if (isCorrect) {
          correctAnswers +=
            state.letters === i18n.t("Ordering.Matching.ShowLetters") ? letterFromNumber(i) : i + 1;
        }
      }
      return (
        <div
          className={"exercisePlugin matchingPlugin"}
          style={{ "--q-btn-hover-bg": state.buttonHoverBackgroundColor || "#ede9fe" }}
        >
          <div className={"row"} key={0}>
            <div className={"col-xs-12"}>
              <PluginPlaceholder
                {...props}
                key="1"
                pluginContainerName={i18n.t("Ordering.Matching.Question")}
                pluginDefaultContent={[
                  {
                    plugin: "BasicText",
                    initialState: { __i18nKey: "Ordering.Matching.Statement" },
                  },
                ]}
                pluginContainer={"Question"}
              />
            </div>
          </div>
          {answers}
          <div
            className={"row feedbackRow"}
            key={-2}
            style={{ display: state.showFeedback ? "block" : "none" }}
          >
            <div
              className={"col-xs-12 feedback"}
              style={{
                color: /* quizColor */ "black",
                borderColor: "#318533",
                backgroundColor: setRgbaAlpha("rgba(39,208,124,0.20)", 0.15),
              }}
            >
              <PluginPlaceholder
                {...props}
                key="-2"
                pluginContainerName={i18n.t("MultipleChoice.Feedback")}
                pluginContainer={"TrueFeedback"}
                pluginDefaultContent={[
                  {
                    plugin: "BasicText",
                    initialState: { __i18nKey: "MultipleChoice.TrueFeedbackMsg" },
                  },
                ]}
              />
            </div>
          </div>
          <div
            className={"row feedbackRow"}
            key={-3}
            style={{ display: state.showFeedback ? "block" : "none" }}
          >
            <div
              className={"col-xs-12 feedback"}
              style={{
                color: /* quizColor */ "black",
                borderColor: "#a31111",
                backgroundColor: setRgbaAlpha("#d51a1a33", 0.15),
              }}
            >
              <PluginPlaceholder
                {...props}
                key="-3"
                pluginContainerName={i18n.t("MultipleChoice.Feedback")}
                pluginContainer={"FalseFeedback"}
                pluginDefaultContent={[
                  {
                    plugin: "BasicText",
                    initialState: { __i18nKey: "MultipleChoice.FalseFeedbackMsg" },
                  },
                ]}
              />
            </div>
          </div>
          <style
            dangerouslySetInnerHTML={{
              __html: `
                    .orderingPlugin input[type="radio"]  {
                      background-color: transparent;
                    }
                   .orderingPlugin input[type="radio"]:checked:after {
                      background-color: ${quizColor};
                    }
                  `,
            }}
          />
        </div>
      );
    },
  };
}
/* eslint-enable react/prop-types */
